module.exports = __webpack_public_path__ + "static/media/home.95f80c44.svg";